<template>
  <div class="animated fadeIn" >
    <fixed-header title="Manage Quickbooks"></fixed-header>
    <b-card class="h-100" body-class="margin-top-fixed-header">
      <div v-if="!onAuthenticationCall">
          <div v-if="mustAuthenticateState">
            <form method="post" :action="authServiceUrl">
              <b-alert show style="text-align: center">
                <b-button type="submit" variant="primary"> Connect to Quickbooks</b-button>
              </b-alert>
            </form>
          </div>
          <div v-else>
            <b-alert :variant="qboActiveState ? 'primary' : 'secondary'" show style="text-align: center">
              <strong>Quickbooks Integration {{ qboActiveState ? 'ON' : 'OFF' }}</strong>
              <div>
                <b-form-checkbox v-if="!onSwitching" switch size="lg" @change="onSwitch" v-model="switchHolder"></b-form-checkbox>
                <span v-if="onSwitching"><i class="fa fa-spinner fa-pulse fa-fw mr-1"></i> Turning {{ qboActiveState ? 'OFF' : 'ON'}}</span>
              </div>
            </b-alert>
            
          </div>
      </div>
      <div v-else>
        <b-alert variant="info" show style="text-align: center"><strong>Checking Quickbooks Connection...</strong></b-alert>
      </div>
      <b-card no-body>
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.qbo-settings variant="info">Default Settings</b-button>
        </b-card-header>
        <b-collapse id="qbo-settings" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            
            <div v-if="isQboSettingsLoaded && qboItems.length > 0">
              <b-form-group label-cols="2" label-align="right" label="Invoice Line Item">
                <b-form-select v-model="qboSettings['quickbookssettings.invoicelineitemrefid']" @change="updateSettings('quickbookssettings.invoicelineitemrefid')">
                  <option v-for="(item, index) in sortedQboItems" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Invoice Charge Item">
                <b-form-select v-model="qboSettings['quickbookssettings.invoicechargeitemrefid']">
                  <option v-for="(item, index) in sortedQboItems" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Bill Line Item">
                <b-form-select v-model="qboSettings['quickbookssettings.billlineitemrefid']">
                  <option v-for="(item, index) in sortedQboItems" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Bill Charge Item">
                <b-form-select v-model="qboSettings['quickbookssettings.billchargeitemrefid']">
                  <option v-for="(item, index) in sortedQboItems" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Expense Item">
                <b-form-select v-model="qboSettings['quickbookssettings.expenseitemrefid']">
                  <option v-for="(item, index) in sortedQboItems" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Expense Payment Account">
                <b-form-select v-model="qboSettings['quickbookssettings.expensepaymentaccount']">
                  <option v-for="(item, index) in paymentAccounts" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Credit Memo Item">
                <b-form-select v-model="qboSettings['quickbookssettings.creditmemoitemrefid']">
                  <option v-for="(item, index) in sortedQboItems" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Vendor Credit Item">
                <b-form-select v-model="qboSettings['quickbookssettings.vendorcredititemrefid']">
                  <option v-for="(item, index) in sortedQboItems" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Refund Receipt Item">
                <b-form-select v-model="qboSettings['quickbookssettings.refundreceiptitemrefid']">
                  <option v-for="(item, index) in sortedQboItems" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label-cols="2" label-align="right" label="Refund Account">
                <b-form-select v-model="qboSettings['quickbookssettings.refundaccount']">
                  <option v-for="(item, index) in paymentAccounts" :key="index" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
            </div>
            <div v-else>
              <b-alert variant="info" show style="text-align: center"><strong>Loading Settings...</strong></b-alert>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body>
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.list-account-items variant="info">QBO Accounts and Items Lists</b-button>
        </b-card-header>
        <b-collapse id="list-account-items" accordion="list-accounts-items" role="tabpanel">
          <b-card-body>
            <div class="h-100" style="display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(1, 1fr);">
              <b-card style="grid-area: 1/1/3/1">
                <template v-slot:header>
                  <h6 class="mb-0">
                    QBO Accounts 
                    <i :class="isAccountRefreshing ? 'fa-pulse' : ''" class="fa fa-refresh ml-2" @click="onRefreshQboAccounts"
                      :style="isAccountRefreshing ? 'color: #aaaaaa' : 'cursor: pointer; color: #00b300;'"></i>
                  </h6>
                </template>
                <qbo-accounts/>
              </b-card>
              <b-card style="grid-area: 2/2/3/2">
                <template v-slot:header>
                  <h6 class="mb-0">
                    QBO Items 
                    <i :class="isItemRefreshing ? 'fa-pulse' : ''" class="fa fa-refresh ml-2" @click="onRefreshQboItems"
                      :style="isItemRefreshing ? 'color: #aaaaaa' : 'cursor: pointer; color: #00b300;'"></i>
                  </h6>
                </template>
                <qbo-items />
              </b-card>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-card>
  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';
import FixedHeader from '@/shared/components/FixedHeader/index';
import QboAccounts from './components/QboAccounts';
import QboItems from './components/QboItems';

export default {
  components: {
    FixedHeader,
    QboAccounts,
    QboItems
  },
  data() {
    return {
      onAuthenticationCall: true,
      onSwitching: false,
      switchHolder: false,
      qboSettings: {},
      settingsResult: [],
      isQboSettingsLoaded: false,
      isItemRefreshing: false,
      isAccountRefreshing: false
    };
  },
  metaInfo: () => ({
    title: 'Quickbooks',
  }),
  computed: {
    ...mapGetters('quickBooks', ['mustAuthenticateState', 'qboSettingState', 'qboItems', 'qboAccounts']),
    authServiceUrl() {
      return process.env.VUE_APP_API_URL + 'api/qbo/initiateAuth';
    },
    qboActiveState() {
      return this.qboSettingState != null && this.qboSettingState.value ? this.qboSettingState.value == '1' : false;
    },
    sortedQboItems() {
      return this.sortSelect(this.qboItems);
    },
    paymentAccounts() {
      return this.sortSelect(this.qboAccounts.filter(x => x.accountType == 'Bank' || x.accountType == 'CreditCard'));
    }
  },
  methods: {
    ...mapActions('quickBooks', ['isMustAuthenticateQbo', 'getQboSettingState', 'switchQboState', 'refreshQboAccounts', 'refreshQboItems']),
    ...mapActions('settings', ['searchByKey', 'manage']),
    async onSwitch() {
      this.onSwitching = true;
      await this.switchQboState().then(async () => {
        await this.getQboSettingState(); 
        this.switchHolder = this.qboActiveState;
      });
      this.onSwitching = false;
    },
    updateSettings(key) {
      let setting = this.settingsResult.find(x => x.key == key);

      if (setting != null && setting.id > 0) {
        setting = { ...setting, value: this.qboSettings[key] };
        this.manage({id: setting.id, setting});
      }
    },
    onRefreshQboAccounts() {
      if (!this.isAccountRefreshing) {
        this.isAccountRefreshing = true;
        this.refreshQboAccounts().then(() => this.isAccountRefreshing = false);  
      }
    },
    onRefreshQboItems() {
      if (!this.isItemRefreshing) {
        this.isItemRefreshing = true;
        this.refreshQboItems().then(() => this.isItemRefreshing = false);  
      }
    }
  },
  async mounted() {
    this.isMustAuthenticateQbo().then(() => {
      this.onAuthenticationCall = false;
    });
    this.getQboSettingState().then(() => this.switchHolder = this.qboActiveState);
    this.searchByKey('quickbooks').then((result) => {
      this.isQboSettingsLoaded = true;
      this.settingsResult = result;
      this.qboSettings = Object.assign({}, ...result.map(s => ({[s.key]: s.value})));
    });
  }
};
</script>